import { render, staticRenderFns } from "./AdminTheme.vue?vue&type=template&id=2358cc04&"
import script from "./AdminTheme.vue?vue&type=script&lang=js&"
export * from "./AdminTheme.vue?vue&type=script&lang=js&"
import style0 from "./AdminTheme.vue?vue&type=style&index=0&id=2358cc04&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports